import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { subscriptionService } from '../../../services/subscriptionService';

const HeroSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex?.test(email);
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!email?.trim()) {
      setError('Email address is required');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);

    try {
      // Use subscribeEmailOnly to save to subscribers table
      const result = await subscriptionService?.subscribeEmailOnly(email);

      if (result?.success) {
        setSubmitSuccess(true);
        setSuccessMessage(result?.message);
        setEmail('');

        setTimeout(() => {
          setSubmitSuccess(false);
          setSuccessMessage('');
        }, 5000);
      } else {
        setError(result?.message);
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
      console.error('Subscription error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitSuccess) {
    return (
      <section className="relative bg-white py-24 lg:py-32">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
          <h1 className="text-5xl lg:text-7xl font-heading font-bold text-primary mb-6">
            Thank You for Subscribing!
          </h1>
          <p className="text-xl text-muted-foreground">
            {successMessage || 'Check your inbox for our welcome email.'}
          </p>
        </div>
      </section>);

  }

  return (
    <section className="relative bg-white py-24 lg:py-32 min-h-screen flex items-center justify-center">
      <div className="max-w-2xl mx-auto px-5 lg:px-8 w-full">
        <div className="text-center">
          <h1 className="text-5xl lg:text-7xl font-heading font-bold text-primary mb-6 leading-tight">Welcome to THEPS, the partner search platform.

          </h1>
          
          <p className="text-xl lg:text-2xl text-primary mb-12">Join the newsletter absolutely free of charge for funding opportunities, news and excellence in project writing!

          </p>

          {/* White rounded card with shadow */}
          <div className="bg-white rounded-2xl shadow-lg p-8 mb-4 max-w-lg mx-auto">
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Email Input */}
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your professional email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e?.target?.value);
                    setError('');
                  }}
                  disabled={isSubmitting}
                  className="w-full px-5 py-4 text-base text-black placeholder:text-black border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white disabled:opacity-50 disabled:cursor-not-allowed" />

                {error &&
                <p className="text-sm text-red-500 mt-2 text-left">{error}</p>
                }
              </div>
              
              {/* Subscribe Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-primary hover:bg-primary/90 text-white font-semibold py-4 px-6 rounded-lg text-base transition-colors disabled:opacity-50 disabled:cursor-not-allowed">

                {isSubmitting ? 'Subscribing...' : "Subscribe Now – It's Free"}
              </button>
            </form>
          </div>
          
          {/* Privacy message with lock icon */}
          <div className="flex items-center justify-center gap-1.5 text-xs text-muted-foreground">
            <Lock className="w-3 h-3" />
            <span className="text-sky-700">No spam, unsubscribe anytime. Privacy guaranteed.</span>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;